module.exports = __webpack_public_path__ + "img/qu2.17c32fbe.png";